import React, { useState, useEffect, useRef } from "react";
import { get } from "lodash";

import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";
/* import genericAction from "@Actions/generic"; */

// Components
/* import Input from "@Components/Input";
import Text from "@Components/Text"; */
import { useReactToPrint } from "react-to-print";
import ConfirmModal from "@Modals/ConfirmModal";
import IKModal from "@Components/IkModal";
import CompanyFields from "@Components/CompanyFields";
import { getTimeLabel } from "@Utils/functionality";

// Assets
/* import { Instagram, Facebook, Telegram, Twitter, Whatsapp } from "@Assets"; */

// Styles

import styles from "./styles.module.css";

const ContactCrud = ({ modalCrud, onClose, tableValue, refresh, companyName, userName, isBlockedSettings }) => {
	const [modalOption, setModalOption] = useState("");
	const [open, setOpen] = useState(false);
	const companyFieldsRef = useRef(null);
	const componentRef = useRef();

	useEffect(() => {
		setModalOption(modalCrud);
	}, [tableValue]);
	useEffect(() => {
		companyFieldsRef.current.isEditable(modalOption !== "Watch");
	}, [modalOption]);

	// saved
	const handlerSaved = async () => {
		if (companyFieldsRef.current) {
			const success = await companyFieldsRef.current.save();
			if (success) {
				refresh();
				onClose();
			}
		}
	};

	const handlePrint = useReactToPrint({
		content: () => {
			return componentRef.current;
		},
	});

	const handlePrintClick = () => {
		handlePrint();
	};

	// modal
	const cancelModal = () => {
		onClose();
	};

	const closeModal = () => {
		setOpen(false);
	};

	const modalOpen = () => {
		let hasChanges = false;
		if (companyFieldsRef.current) {
			hasChanges = companyFieldsRef.current.validChange();
		}
		if (hasChanges) {
			setOpen(true);
		} else {
			onClose();
		}
	};

	return (
		<IKModal
			title={modalOption === "Add" ? " Agregar Contacto " : `Contacto : ${get(tableValue, "name", "")} - Id: ${String(tableValue.id)}`}
			size="tiny"
			mode={modalOption}
			setMode={setModalOption}
			onClose={modalOpen}
			printAction={handlePrintClick}
			fullHeight
			onSuccess={handlerSaved}>
			<div className={`${styles.container} ${styles.printContainer}`} ref={componentRef}>
				<div className={styles.printOnly}>
					<h1 className={styles.companyTitle}>{companyName}</h1>
					<h2 className={styles.subtitle}>Contactos</h2>
					<p className={styles.userName}>
						<span className={styles.headerTitlesss}>Usuario:</span>
						{userName}
					</p>
					<p className={styles.userName}>
						<span className={styles.headerTitlesss}>Fecha:</span>
						{getTimeLabel(new Date(), "DD/MM/YYYY, hh:mm A")}
					</p>
				</div>
				<div className={styles.printSection}>
					<CompanyFields
						contactData={tableValue}
						phoneEdit
						disabledSaveButton
						disableFloatingButton
						ref={companyFieldsRef}
						showChannel
						noSendQuestion
						disablePrintButton
						noDisableStaticFields
						highlightBlocked={isBlockedSettings}
					/>
				</div>
			</div>

			{open && (
				<ConfirmModal
					visible
					header="Salir del formulario"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={closeModal}
				/>
			)}
		</IKModal>
	);
};

function mapStateToProps({ user, company }) {
	return {
		contact: [],
		categoryData: [],
		companyName: company.name,
		userName: user.name,
		isBlockedSettings: company.settings.isBlocked,
	};
}
ContactCrud.propTypes = {
	onClose: PropTypes.func,
	refresh: PropTypes.func,
	tableValue: PropTypes.array,
	modalCrud: PropTypes.string,
	companyName: PropTypes.string,
	userName: PropTypes.string,
	isBlockedSettings: PropTypes.bool,
};
export default connect(mapStateToProps)(ContactCrud);
